export const CHAT_LIST_ENDPOINT = `${process.env.REACT_APP_API_BACKEND_CHAT}chat/list`;
export const CHAT_API_URL = `${process.env.REACT_APP_API_BACKEND_CHAT}/v2`

